const list = {
    index: 'Index/Index', 
    
};

export default list;